<template>
  <v-app>
    <v-navigation-drawer app color="#282B32" dark>
      <main-nav></main-nav>
      <template v-slot:append v-if="authenticated">
        <div class="pa-2">
          <v-btn block text @click="logout">Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <!-- <v-app-bar flat dense app color="white">
      <v-spacer></v-spacer>
      <v-btn v-if="!authenticated" text color="black" :to="{ name: 'SignIn' }">
        <v-icon>mdi-account</v-icon> Login
      </v-btn>

      <v-btn v-else text color="black" @click="logout"> <v-icon>mdi-power</v-icon> Logout </v-btn>
    </v-app-bar>-->
    <v-main>
      <router-view />
    </v-main>
    <messages></messages>
  </v-app>
</template>
<script>
import MainNav from "./components/MainNav";
import { mapState, mapActions } from "vuex";
import EventBus from "./event_bus";

export default {
  components: {
    "main-nav": MainNav
  },
  data() {
    return {
      drawer: null
    };
  },
  computed: {
    ...mapState("auth", ["authenticated"])
  },
  methods: {
    ...mapActions("auth", {
      logout: "logout"
    })
  },
  mounted() {
    EventBus.$on("login", () => {
      this.$router.push({ name: "home" });
    });
  }
};
</script>
<style lang="scss"></style>
